import script from "./baseTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./baseTooltip.vue?vue&type=script&setup=true&lang=js"

import "./baseTooltip.vue?vue&type=style&index=0&id=0caa6e30&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0caa6e30"]])

export default __exports__